import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OktaAuthService } from '@eda/core/services/okta-auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OktaRefreshInterceptor implements HttpInterceptor {
  private oktaService = inject(OktaAuthService);
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes(environment.apigeeConfig.domain)) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Centralized error handling
        switch (error.status) {
          case 401: // Unauthorized
            this.oktaService.logout();
            break;
          case 403: // Forbidden
            this.oktaService.logout();
            break;
          default:
            // Handle other errors (e.g., display a generic message)
            console.error(`HTTP Error: ${error.status}`, error.message);
        }

        // Re-throw the error to propagate it further (e.g., to the component that made the request)
        return throwError(() => error);
      })
    );
  }
  
}
